import { Flex } from '@mantine/core';
import { useMediaQuery, useOs } from '@mantine/hooks';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import './AuthLayout.scss';
import { ASSETS_BUCKET_URL } from '@/config';
import { OfflineContainer } from '@/containers/OfflineContainer';
import storage from '@/utils/storage';

type LayoutProps = {
  children: React.ReactNode;
  page: string;
  path?: string | number;
};

export const AuthLayout = ({ children, page, path }: LayoutProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)', true);
  const os = useOs();
  const config = storage.getItem('config');
  // useEffect on effect sabve to server

  const navigate = useNavigate();

  const bannerImages = [
    {
      page: 'login',
      image: `${ASSETS_BUCKET_URL}/svg/Login.svg`,
      mobileImage: `${ASSETS_BUCKET_URL}/svg/LoginMobile.svg`,
    },
    {
      page: 'signup',
      image: `${ASSETS_BUCKET_URL}/svg/Signup.svg`,
      mobileImage: `${ASSETS_BUCKET_URL}/svg/SignupMobile.svg`,
    },
    {
      page: 'set-password',
      image: `${ASSETS_BUCKET_URL}/svg/AuthSkipDesktop.svg`,
      mobileImage: `${ASSETS_BUCKET_URL}/svg/AuthSkipMobile.svg`,
    },
    {
      page: 'login-with-otp',
      image: `${ASSETS_BUCKET_URL}/svg/AuthSkipDesktop.svg`,
      mobileImage: `${ASSETS_BUCKET_URL}/svg/AuthSkipMobile.svg`,
    },
    {
      page: 'login-with-mobile-otp',
      image: `${ASSETS_BUCKET_URL}/svg/Signup.svg`,
      mobileImage: `${ASSETS_BUCKET_URL}/svg/SignupMobile.svg`,
    },
  ];
  return (
    <OfflineContainer showOfflinePopup isPrelogin>
      <Flex
        direction={{ base: 'column', sm: 'row' }}
        justify={{ base: 'center', sm: 'flex-start' }}
        align="center"
      >
        <div className="banner-wrapper">
          <div className={os === 'ios' || os === 'macos' ? 'close-icon-ios' : 'close-icon'}>
            {page === 'login-with-mobile-otp' && !config?.auth_skip ? null : (
              <img
                src={`${ASSETS_BUCKET_URL}/svg/ArrowBackWhite.svg`}
                className="icon-s3-md"
                alt="ArrowBackWhite"
                loading="lazy"
                onClick={() => {
                  if (path) {
                    if (path === -1) {
                      navigate(-1);
                    } else {
                      navigate(path.toString());
                    }
                  } else {
                    navigate(-1);
                  }
                }}
              />
            )}
          </div>

          <img
            src={
              isMobile
                ? bannerImages.find((item) => item.page === page)?.mobileImage
                : bannerImages.find((item) => item.page === page)?.image
            }
            alt="banner"
          />
        </div>

        <div className="form">
          <div className="form-wrapper">{children}</div>
        </div>
      </Flex>
    </OfflineContainer>
  );
};
